/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppearanceStyle } from './AppearanceStyle';
import {
    AppearanceStyleFromJSON,
    AppearanceStyleFromJSONTyped,
    AppearanceStyleToJSON,
    AppearanceStyleToJSONTyped,
} from './AppearanceStyle';
import type { ColorPaletteId } from './ColorPaletteId';
import {
    ColorPaletteIdFromJSON,
    ColorPaletteIdFromJSONTyped,
    ColorPaletteIdToJSON,
    ColorPaletteIdToJSONTyped,
} from './ColorPaletteId';
import type { ThemeMode } from './ThemeMode';
import {
    ThemeModeFromJSON,
    ThemeModeFromJSONTyped,
    ThemeModeToJSON,
    ThemeModeToJSONTyped,
} from './ThemeMode';
import type { FontSize } from './FontSize';
import {
    FontSizeFromJSON,
    FontSizeFromJSONTyped,
    FontSizeToJSON,
    FontSizeToJSONTyped,
} from './FontSize';

/**
 * 
 * @export
 * @interface UpdatePersonalizationRequest
 */
export interface UpdatePersonalizationRequest {
    /**
     * 
     * @type {ColorPaletteId}
     * @memberof UpdatePersonalizationRequest
     */
    colorPaletteId: ColorPaletteId;
    /**
     * 
     * @type {AppearanceStyle}
     * @memberof UpdatePersonalizationRequest
     */
    dashboardAppearance: AppearanceStyle;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalizationRequest
     */
    customColor: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePersonalizationRequest
     */
    grainEnabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePersonalizationRequest
     */
    gradientEnabled: boolean | null;
    /**
     * 
     * @type {ThemeMode}
     * @memberof UpdatePersonalizationRequest
     */
    themeModeControl: ThemeMode | null;
    /**
     * 
     * @type {FontSize}
     * @memberof UpdatePersonalizationRequest
     */
    fontSize: FontSize | null;
}



/**
 * Check if a given object implements the UpdatePersonalizationRequest interface.
 */
export function instanceOfUpdatePersonalizationRequest(value: object): value is UpdatePersonalizationRequest {
    if (!('colorPaletteId' in value) || value['colorPaletteId'] === undefined) return false;
    if (!('dashboardAppearance' in value) || value['dashboardAppearance'] === undefined) return false;
    if (!('customColor' in value) || value['customColor'] === undefined) return false;
    if (!('grainEnabled' in value) || value['grainEnabled'] === undefined) return false;
    if (!('gradientEnabled' in value) || value['gradientEnabled'] === undefined) return false;
    if (!('themeModeControl' in value) || value['themeModeControl'] === undefined) return false;
    if (!('fontSize' in value) || value['fontSize'] === undefined) return false;
    return true;
}

export function UpdatePersonalizationRequestFromJSON(json: any): UpdatePersonalizationRequest {
    return UpdatePersonalizationRequestFromJSONTyped(json, false);
}

export function UpdatePersonalizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonalizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'colorPaletteId': ColorPaletteIdFromJSON(json['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleFromJSON(json['dashboardAppearance']),
        'customColor': json['customColor'],
        'grainEnabled': json['grainEnabled'],
        'gradientEnabled': json['gradientEnabled'],
        'themeModeControl': ThemeModeFromJSON(json['themeModeControl']),
        'fontSize': FontSizeFromJSON(json['fontSize']),
    };
}

export function UpdatePersonalizationRequestToJSON(json: any): UpdatePersonalizationRequest {
    return UpdatePersonalizationRequestToJSONTyped(json, false);
}

export function UpdatePersonalizationRequestToJSONTyped(value?: UpdatePersonalizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'colorPaletteId': ColorPaletteIdToJSON(value['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleToJSON(value['dashboardAppearance']),
        'customColor': value['customColor'],
        'grainEnabled': value['grainEnabled'],
        'gradientEnabled': value['gradientEnabled'],
        'themeModeControl': ThemeModeToJSON(value['themeModeControl']),
        'fontSize': FontSizeToJSON(value['fontSize']),
    };
}

